import TranslationsOnImage from '@/shared/TranslationsOnImage/TranslationsOnImage';
import { StyledImagePage } from './ImagePage.styled';
import useImagePage from './useImagePage.hook';
import { useRef } from 'react';
import AudioPlayPauseButton from '../../components/AudioPlayPauseButton/AudioPlayPauseButton';

export default function ImagePage({ page, folder, activityActions, editing }) {
  const imgRef = useRef(null);
  useImagePage({
    page,
    activityActions,
  });

  const cloudFolder = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${folder}`;
  const audio = page.data.audio || `audios/${page.id}.mp3`;
  const audioSrc = `${cloudFolder}/${audio}`;
  const img = page.data.img || `imgs/${page.id}.webp`;
  const imgSrc = `${cloudFolder}/${img}`;

  return (
    <StyledImagePage>
      <img className="image" src={imgSrc} alt="" ref={imgRef} />
      <TranslationsOnImage
        imgRef={imgRef}
        translations={page.translations}
        editing={editing}
        className="centered-translations"
      />
      <div className="audio-container">
        <AudioPlayPauseButton
          size="large"
          src={audioSrc}
          className="audio-player"
          doPlay={!editing}
        />
      </div>
    </StyledImagePage>
  );
}
